<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<!-- 高新园用的招生 -->
		<div style="padding: 15px;">
			<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
			<van-cell-group>

				<van-field :readonly="disabled" v-model="stuForm.stu_name" label="考生姓名" placeholder="请输入姓名" required />
				<van-field :readonly="disabled" v-model="stuForm.archive" label="建档号" placeholder="请输入建档号" required>
					<template #right-icon>
						<el-tag size="small" @click="showTips" effect="plain" type="danger">填写须知</el-tag>
					</template>
				</van-field>
				<van-field :readonly="disabled" v-model="stuForm.exam_num" label="考试证号" placeholder="请输入准考证号" required>
					<template #right-icon>
						<el-tag size="small" @click="showTips" effect="plain" type="danger">填写须知</el-tag>
					</template>
				</van-field>

				<van-cell title="性别" required>

					<template #right-icon>
						<van-radio-group :disabled="disabled" :readonly="disabled" v-model="stuForm.gender"
							direction="horizontal">
							<van-radio :name="1">男</van-radio>
							<van-radio :name="2">女</van-radio>
						</van-radio-group>
					</template>
				</van-cell>

				<!-- <van-field v-model="stuForm.phone" type="tel" label="手机号" placeholder="请输入手机号" required /> -->



				<van-field :readonly="disabled" v-model="stuForm.graduate_sch_city" is-link readonly label="毕业地区"
					placeholder="毕业地区" @click="()=>{if(!disabled){showCity = true}}" required />
				<van-popup v-model="showCity" round position="bottom">
					<van-cascader v-model="distCode" title="请选择所在地区" active-color="#1989fa" :options="citys"
						:field-names="fieldNames" @close="showCity = false" @finish="onCheckCity"
						@change="cityChange" />
				</van-popup>

				<div class="flexBetween">
					<van-field v-model="stuForm.graduate_schname2" :readonly="disabled" label="毕业学校" placeholder="毕业学校"
						required>
						<template #right-icon>
							<van-tag v-if="!disabled" round type="primary"
								@click="()=>{if(!disabled){showSchool = true}}"
								style="white-space: nowrap;display: flex;justify-content: center;align-items: center">
								选择
							</van-tag>
						</template>
					</van-field>
				</div>
				<van-popup v-model="showSchool" round position="bottom">
					<van-cascader v-model="stuForm.graduate_schid" :readonly="stuForm.id" title="请选择毕业学校"
						active-color="#1989fa" :options="schools" :field-names="fieldSchools"
						@close="showSchool = false" @finish="onCheckSchool" @change="cityChange" />
				</van-popup>
				<!--				<van-field v-model="stuForm.graduate_schname2" v-if="stuForm.graduate_schid==0" label="学校名称"-->
				<!--					placeholder="毕业学校" required />-->

				<van-field :readonly="disabled" v-model="stuForm.exam_score" type="number" label="中考成绩"
					:placeholder="AreaScore>0?'分数线:'+AreaScore:'中考成绩数'" required />

				<van-field :readonly="disabled" v-model="stuForm.jhr1name" label="家长姓名1" placeholder="请输入家长姓名1"
					required />
				<van-field :readonly="disabled" v-model="stuForm.jhr1phone" label="联系号码" placeholder="请输入家长姓名1联系号码"
					required />
				<van-field :readonly="disabled" v-model="stuForm.jhr2name" label="家长姓名2" placeholder="请输入家长姓名2" />
				<van-field :readonly="disabled" v-model="stuForm.jhr2phone" label="联系号码" placeholder="请输入家长姓名2联系号码" />


				<van-field v-model="stuForm.major_name" is-link readonly label="报考专业1" placeholder="请选择第一报考专业"
					@click="()=>{if(!disabled){showMj1 = true}}" required />
				<van-popup v-model="showMj1" round position="bottom">
					<van-cascader v-model="stuForm.major_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj1 = false" @finish="onCheckMajor1" />
				</van-popup>

				<van-field v-model="stuForm.major_name2" is-link readonly label="报考专业2" placeholder="请选择第二报考专业"
					@click="()=>{if(!disabled){showMj2 = true}}" />
				<van-popup v-model="showMj2" round position="bottom">
					<van-cascader v-model="stuForm.major_id2" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj2 = false" @finish="onCheckMajor2" />
				</van-popup>

				<van-field v-model="stuForm.major_name3" is-link readonly label="报考专业3" placeholder="请选择第三报考专业"
					@click="()=>{if(!disabled){showMj3 = true}}" />
				<van-popup v-model="showMj3" round position="bottom">
					<van-cascader v-model="stuForm.major_id3" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj3 = false" @finish="onCheckMajor3" />
				</van-popup>
				
				<div class="rowlb">
					<span></span>
					其他附件 <div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">免美术加试和专业面试的请上传相关证明！</div>
				</div>
				<van-field name="uploader5" label="附件1">
					<template #input>
						<div class="imagebox" @click="setImageType('other1')">
							<van-icon name="photo-o" v-if="!pjson.other1" />
							<img v-else :src="pjson.other1" style="width: 100%; height: 100%;">

						</div>

					</template>
				</van-field>


				<van-field name="uploader5" label="附件2">
					<template #input>
						<div class="imagebox" @click="setImageType('other2')">
							<van-icon name="photo-o" v-if="!pjson.other2" />
							<img v-else :src="pjson.other2" style="width: 100%; height: 100%;">

						</div>

					</template>
				</van-field>









				<van-field v-if="false" v-model="stuForm.remark" rows="2" autosize label="备注" type="textarea"
					maxlength="200" placeholder="请输入备注" show-word-limit />
				<div class="item-input item-input1">
					请家长确保登记信息准确无误


				</div>


				<!-- <van-field name="uploader5" label="家长签字" required>
					<template #input>
						<div @click="showhandsign = true"
							style="width: 150px; height: 75px; background-color: #F2F3F5; line-height: 75px; text-align: center;">
							<span v-if="!pjson.handsign">
								<van-icon name="flag-o" />点击签名
							</span>
							<img v-else :src="pjson.handsign" style="width: 100%;height: 100%;">
						</div>

					</template>
				</van-field> -->

				<div class="submitBtn flexCenter" v-if="!disabled">
					<div class="btn flexCenter" @click="saveStu">提交</div>
				</div>
				<!-- <div v-if="disabled" class="submitBtn flexAround">
					<div class="btn" @click="onModify" style="width: 40%;">修改</div>
				</div> -->

				<div style="height:10px;"></div>


			</van-cell-group>
		</div>
		
		<div v-if="showhandsign" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);">
			<handSign  @returnImg="getHandSign"></handSign>
		</div>
		
	</div>
</template>

<script>
	import {
		Dialog,
		Toast
	} from 'vant';
	import wx from 'weixin-js-sdk'
	import handSign from "../../com/handSign.vue"
	export default {
components:{
			handSign
		},
		data() {
			return {
				school_name: "",
				pmid: 0,
				openid: "",
				stuForm: {
					stu_name: "",
					archive: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					oldname: '',
					exam_num: '',
					remark: "",
					jhr1name: "",
					jhr1phone: "",
					jhr2name: "",
					jhr2phone: ""

				},
				pjson: {
				
					nation: "",
					idtype: "",
					idsdate: "",
					idedate: "",
					height: "",
					weight: "",
					size: "",
					remark: "",
					identity_card1: "",
					identity_card2: "",
					dzzj: "",
					other1: '',
					other2: '',
					handsign:""
				
				},
				imgname: "",
				showhandsign:false,
				
				showCity: false,
				showSchool: false,
				citys: [],
				schools: [],
				majors: [],
				distCode: '',
				fieldNames: {
					text: 'label',
					value: 'code',
					children: 'children',
				},
				fieldSchools: {
					text: 'school_name',
					value: 'id',
					children: 'children',
				},
				fieldMajors: {
					text: 'title',
					value: 'id',
					children: 'children',
				},
				showMj1: false,
				showMj2: false,
				showMj3: false,
				showBtn: false,
				stu_from_type: 0,
				disabled: false,
				AreaScore: 0,
				AreaScoreList: []
			}
		},
		mounted() {
			$(".page").height($(window).height())
			document.title = "中考登记"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid

			window.pmid = this.pmid

			// this.pmid = 4
			// this.openid = 'oWsp85Bz3tDnWAC280W9bHMnUNcA'

			this.getStudents()
			this.checkUrlSign(wx)

		},
		methods: {
			setImageType(e) {
				this.imgname = e
				this.chooseImageWx()
			},
			chooseImage(e) {
			
				this.pjson[this.imgname] = e.url
			},
			chooseImageWx() {
				wx.chooseImage({
					count: 1, // 默认9
					sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
					sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
					success: (res) => {
						wx.uploadImage({
							localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
							isShowProgressTips: 1, // 默认为1，显示进度提示
							success: (res2) => {
								var serverId = res2.serverId; // 返回图片的服务器端ID
								this.$http.post("/api/get_wximage", {
									serverId: serverId
								}).then(data => {
									// alert(JSON.stringify(data.data))
									console.log(data.data.url)
									this.chooseImage(data.data)
								})
							}
						});
					}
				});
			},
			getHandSign(e){
				console.log(e)
				
				this.showhandsign = false
				if(e){
					this.$http.post("/api/save_base64_img",{base64_img:e}).then(res=>{
						this.pjson.handsign = res.data.url
					})
				}
				
			},
			getAreaMajorScoreLine() {
				this.$http.post("/api/get_area_major_score_line", {
					pmid: this.pmid
				}).then(res => {
					this.AreaScoreList = res.data

					//检查分数线
					if (this.stuForm.id) {
						for (let p of this.AreaScoreList) {
							for (let c of p.children) {

								if (this.stuForm.graduate_sch_city.indexOf(c.area_name) >= 0) {
									this.AreaScore = c.score_line
									break
								}
							}
						}
					}



				})
			},

			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data) {
						if (!res.data.otherjson) {
							res.data.otherjson =this.pjson
						} else {
							res.data.otherjson = JSON.parse(res.data.otherjson)
						}
						this.pjson = res.data.otherjson
						this.stuForm = res.data
						this.stuForm.graduate_schname2 = res.data.graduate_schname
						if(this.stuForm.status>=1){
							this.disabled = true
							
						}else{
							this.onModify()
						}
					} else {
						this.showBtn = true
						this.disabled = false
					}

					this.getSchoolName()
					this.getSchoolArea()
					this.getMajorList()
					this.getAreaMajorScoreLine()
				})
			},
			getSchoolName() {
				this.$http.post("/api/app_platform_info", {
					pmid: this.pmid
				}).then(res => {
					this.school_name = res.data.platform
				})
			},
			getSchools() {

				this.$http.post("/api/app_area_school_list", {
					pmid: this.pmid,
					dist_code: this.distCode
				}).then(res => {
					res.data.push({
						id: 0,
						school_name: "其他学校"
					})
					this.schools = res.data
				})
			},
			getSchoolArea() {

				this.$http.post("/api/sys_finish_school_area", {
					pmid: this.pmid
				}).then(res => {
					for (let a of res.data) {
						for (let b of a.children) {
							for (let c of b.children) {
								delete c.children
							}
						}
					}
					this.citys = res.data
					console.log(this.citys)
				})
			},
			cityChange(e) {
				console.log(e)
			},
			onCheckCity({
				selectedOptions
			}) {
				this.showCity = false;

				this.stuForm.graduate_sch_city = selectedOptions.map((option) => option.label).join(',');
				this.stuForm.graduate_dist_code = selectedOptions[2].code
				this.getSchools()

				//检查分数线
				for (let p of this.AreaScoreList) {
					for (let c of p.children) {

						if (selectedOptions[1].code == c.area_code) {
							this.AreaScore = c.score_line
							break
						}
					}
				}


			},
			onCheckSchool({
				selectedOptions
			}) {
				this.showSchool = false;
				this.stuForm.graduate_schid = selectedOptions.map((option) => option.id).join(',');
				this.stuForm.graduate_schname = selectedOptions.map((option) => option.school_name).join(',');
				this.stuForm.graduate_schname2 = selectedOptions.map((option) => option.school_name).join(',');
			},
			onCheckMajor1(e) {
				this.stuForm.major_id = e.selectedOptions[0].id
				this.stuForm.major_name = e.selectedOptions[0].title
				this.showMj1 = false
			},
			onCheckMajor2(e) {
				this.stuForm.major_id2 = e.selectedOptions[0].id
				this.stuForm.major_name2 = e.selectedOptions[0].title
				this.showMj2 = false
			},
			onCheckMajor3(e) {
				this.stuForm.major_id3 = e.selectedOptions[0].id
				this.stuForm.major_name3 = e.selectedOptions[0].title
				this.showMj3 = false
			},
			getMajorList() {
				this.$http.post("/api/app_major_list", {
					pmid: this.pmid,
					node_type: "major"
				}).then(res => {
					this.majors = res.data
					if (this.stuForm.major_id) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id) {
								this.stuForm.major_name = item.title
							}
						}
					}
					if (this.stuForm.major_id2) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id2) {
								this.stuForm.major_name2 = item.title
							}
						}
					}
					if (this.stuForm.major_id3) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id3) {
								this.stuForm.major_name3 = item.title
							}
						}
					}


				})

			},
			saveStu() {
				if (this.AreaScore > this.stuForm.exam_score &&this.stuForm.exam_score) {
					Toast('低于' + this.AreaScore + "分数线无法登记");
					return
				}
				if (!this.stuForm.stu_name) {
					Toast('请输入姓名');
					return
				}
				if (!this.stuForm.gender) {
					Toast('请选择性别');
					return
				}
				if (!this.stuForm.jhr1phone) {
					Toast('请输入手机号');
					return
				}
				if (!this.stuForm.exam_num) {
					Toast('请输入准考证号');
					return
				}
				if (!this.stuForm.major_id) {
					Toast('请选择报考专业');
					return
				}
				if (this.stuForm.volunteer === '') {
					this.stuForm.volunteer = 0
				}
				if (!this.stuForm.graduate_sch_city) {
					Toast('请选择毕业地区');
					return
				}
				if (!this.stuForm.graduate_schname&&!this.stuForm.graduate_schname2) {
					Toast('请选择或输入学校名称');
					return
				}
				if (this.stuForm.graduate_schname == '其他学校' && !this.stuForm.graduate_schname2) {
					Toast('请输入学校名称');
					return
				}
				if (this.stuForm.graduate_schname == '其他学校' && this.stuForm.graduate_schname2) {
					this.stuForm.graduate_schname = this.stuForm.graduate_schname2
				}
				
				
				// if (!this.pjson.handsign) {
				// 	Toast('请签名');
				// 	return
				// }
				
				
				
				this.stuForm.pmid = window.pmid
				this.stuForm.openid = this.openid
				this.stuForm.stu_from_type = this.stu_from_type
				//选择学校后**
				if (!this.stuForm.graduate_schname || (this.stuForm.graduate_schname != this.stuForm.graduate_schname2)) {
					this.stuForm.graduate_schid = 0
					this.stuForm.graduate_schname = this.stuForm.graduate_schname2
				}
				this.stuForm.otherjson = JSON.parse(JSON.stringify(this.pjson))
				
				
				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if(res.data.status>=1){
						Toast.success('已审核通过无法修改~');
						this.disabled = true
					}else{
						this.$http.post("/api/app_stu_form", this.stuForm).then(res => {
						
							if (res.data.id) {
								this.stuForm.id = res.data.id
						
								Toast.success('登记成功，请耐心等待审核~');
								
							} else {
								if (res.data.code && res.data.code != 200) {
									Toast.success(res.data.msg);
								} else {
									Toast.success('提交成功~');
								}
							}
						})
					}
					
				})


			},

			onModify() {
				this.distCode = this.stuForm.graduate_dist_code
				this.disabled = false
				this.showBtn = true
				this.getSchools()
			},
			showTips() {
				let _this = this
				Dialog.alert({
					title: "提示",
					message: '南京市中考考生填报：建档号和考试证号以中考准考证为准。江苏其他地区中考考生填报：中考准考证上只有1个号码的，建档号和考证号填写相同的。中考准考证上有2个号码的，分别将2个号码依次填写到建档号和考证号中。',
					messageAlign: 'left',
					showCancelButton: false,
					confirmButtonText: "关闭",
					confirmButtonColor: '#00cfdc',
				}).then(() => {
					console.log("点击了关闭按钮噢")


				}).catch(() => {
					console.log("点击了取消按钮噢")
				})
			},
		},
	}
</script>

<style lang="less" type="text/less">
	.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #00cfdc;
  border-color: #00cfdc;
}
	.submitBtn {
        margin-top: 2vh;
		margin-bottom: 50px;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
			width: 50%;
			text-align:center;
        }
		.btn:active {

		    background-color: #007AFF;

		}
    }

  .item-input{
    position: relative;
    box-sizing: border-box;width: 100%;
    padding: 10px 16px;
    font-size: 14px;color: #646566;
  }
  .item-input1{
    color: #ee0a24;
    font-size: 12px;
    line-height: 18px;
  }
  .item-input1::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
.imagebox{ border:1px dotted #ccc; width: 100px; height: 100px; background-color: #F2F3F5; display: flex; align-items: center;justify-content: center; font-size: 40px; color:#ccc}
</style>